import './style.scss';
import { Slider } from '../../../js/components/Slider/Slider';

export default !function () {
  const blocks = document.querySelectorAll('.universal-large-gallery');

  if (!blocks.length) {
    return;
  }

  blocks.forEach((block) => {
    const sliderContainer = block.querySelector('.universal-large-gallery__wrapper');
    const slides = sliderContainer.querySelectorAll('.universal-large-gallery__item');
    const controls = sliderContainer.querySelector('.universal-large-gallery__controls');
    const isInit = slides.length > 1;

    const options = {
      wrapper: sliderContainer,
      lazy: true,
      settings: {
        spaceBetween: 8,
        focusableElements: true,

        fadeEffect: {
          crossFade: true
        },

        slideClass: 'universal-large-gallery__item',
        wrapperClass: 'universal-large-gallery__list',

        navigation: {
          nextEl: '.button-arrow--next',
          prevEl: '.button-arrow--prev'
        },

        media: {
          lg: {
            loop: false,
            effect: 'slide'
          },
          xl: {
            loop: true,
            effect: 'fade'
          }
        },

        breakpoints: {
          1024: {
            spaceBetween: 8
          },
          1280: {
            spaceBetween: 0
          }
        },
      },
      modules: ['navigation', 'effectFade', 'a11y'],
      initCondition: {
        sm: isInit,
        md: isInit,
        lg: isInit,
        xl: isInit
      },
      controls
    };

    new Slider(options).init();
  });
}();
